import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #f8f8f8;
  padding: 16px 24px;
  font-size: 12px;
  line-height: 17px;
`
